var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownallaccordions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17091",
    "data-name": "Group 17091",
    transform: "translate(-50 -572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3734",
    "data-name": "Rectangle 3734",
    transform: "translate(79 601) rotate(180)",
    fill: "#2468ff",
    stroke: "#2468ff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M11.352,7.953,6.435,3.035,1.518,7.953,0,6.435,6.435,0,12.87,6.435Z",
    transform: "translate(71.004 587.476) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38186",
    "data-name": "Path 38186",
    d: "M11.352,7.953,6.435,3.035,1.518,7.953,0,6.435,6.435,0,12.87,6.435Z",
    transform: "translate(71.004 593.476) rotate(180)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownallaccordions);
export default __webpack_public_path__ + "static/media/Down all accordions.079ed4a1.svg";
export { ForwardRef as ReactComponent };